import {
  type ModalSizeType,
  type ModalSize,
  LinkTarget,
  type CFSceneSwitchType,
  type OpenStyle,
} from '@types';
import type { DropdownItem } from '@components/Dropdown';

export const linkTargetItems: DropdownItem<LinkTarget>[] = [
  { id: LinkTarget.blank, name: '新窗口打开' },
  { id: LinkTarget.window, name: '本窗口打开' },
  { id: LinkTarget.modal, name: '弹出层打开' },
];

export const modalSizeTypeItems: DropdownItem<ModalSizeType>[] = [
  { id: 0, name: '系统默认' },
  { id: 1, name: '自定义' },
];

export const modalSizeSuffixItems: DropdownItem<'%' | 'px'>[] = [
  { id: '%', name: '%' },
  { id: 'px', name: 'px' },
];

export const defaultModalSize: ModalSize = {
  pc: { width: '90%', height: '90%' },
  mobile: { width: '100%', height: '100%' },
};

export const correctingModalSizeValue = (
  val: string,
  activeModalSize: 0 | 1,
  oldVal: string,
  isWidth: boolean,
  autoModify?: boolean
): string => {
  let newVal = val
    .split('')
    .filter((a) => '0123456789'.includes(a))
    .join('');
  if (autoModify && oldVal.endsWith('%') && Number.parseInt(newVal) > 100) {
    newVal = '100';
  }
  if (autoModify && newVal.length === 0 && activeModalSize === 0) {
    // eslint-disable-next-line no-nested-ternary
    newVal = oldVal.endsWith('%') ? '90' : isWidth ? '1200' : '700';
  } else if (autoModify && newVal.length === 0 && activeModalSize === 1) {
    newVal = oldVal.endsWith('%') ? '100' : '700';
  }
  return newVal;
};

export const switchTypeItems: DropdownItem<CFSceneSwitchType>[] = [
  { id: 0, name: '淡入淡出' },
  { id: 1, name: '缩放过渡' },
  { id: 2, name: '黑场过渡' },
  { id: 3, name: '白场过渡' },
  { id: 4, name: '从右至左' },
  { id: 5, name: '对角线' },
  { id: 6, name: '圆形展开' },
  { id: 7, name: '水平展开' },
  { id: 8, name: '椭圆缩放' },
];

export const openStyleItems: DropdownItem<OpenStyle>[] = [
  { id: 0, name: '白色边框弹窗' },
  { id: 1, name: '半透明蒙层弹窗' },
];
